var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "szwtpyirba",
    x1: "75.555%",
    x2: "40.992%",
    y1: "90.012%",
    y2: "35.896%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F89F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25.02%",
    stopColor: "#F79A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.31%",
    stopColor: "#F68D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.96%",
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.32%",
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jnte3nu4mb",
    x1: "70.098%",
    x2: "19.584%",
    y1: "89.284%",
    y2: "-9.451%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35.87%",
    stopColor: "#E16F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70.3%",
    stopColor: "#D4602C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "98.16%",
    stopColor: "#D05B2E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1089 -451) translate(420 305) translate(0 130) translate(669 16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0.12 0.175L34.871 0.175 34.871 22.299 0.129 22.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48120",
    d: "M34.751 12.48s-9.496 6.696-26.885 9.699H34.75V12.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M34.871.046H0v22.382h35V.037h-.129v.01zm-.12.249V22.17H.258V.295H34.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M3.058 6.89H1.612v5.065h1.446c.764 0 1.317-.184 1.805-.58.58-.479.921-1.197.921-1.943-.009-1.502-1.123-2.543-2.726-2.543zm1.16 3.813c-.313.276-.709.405-1.354.405h-.267V7.755h.267c.636 0 1.023.11 1.354.406.341.303.544.773.544 1.261 0 .489-.203.977-.544 1.28zM6.236 6.889H7.236V11.955H6.236zM9.634 8.833c-.59-.221-.764-.369-.764-.636 0-.322.313-.561.737-.561.294 0 .543.12.792.414l.515-.672c-.423-.369-.93-.562-1.492-.562-.893 0-1.584.626-1.584 1.455 0 .7.323 1.06 1.244 1.39.386.139.58.231.681.286.194.13.295.314.295.525 0 .415-.322.719-.765.719-.47 0-.847-.24-1.077-.673l-.636.618c.452.672 1.004.967 1.75.967 1.023 0 1.75-.682 1.75-1.667.019-.82-.322-1.189-1.446-1.603zM11.403 9.432c0 1.492 1.17 2.643 2.67 2.643.424 0 .793-.083 1.235-.295v-1.16c-.396.396-.746.552-1.188.552-.995 0-1.704-.718-1.704-1.75 0-.976.727-1.74 1.658-1.74.47 0 .829.165 1.234.57v-1.16c-.433-.22-.792-.313-1.216-.313-1.483 0-2.69 1.179-2.69 2.653zM23.155 10.297L21.801 6.889 20.724 6.889 22.87 12.084 23.404 12.084 25.587 6.889 24.518 6.889zM26.038 11.955L28.838 11.955 28.838 11.099 27.024 11.099 27.024 9.736 28.774 9.736 28.774 8.879 27.024 8.879 27.024 7.755 28.838 7.755 28.838 6.889 26.038 6.889zM32.753 8.39c0-.948-.654-1.491-1.796-1.491h-1.465v5.065h.986V9.93h.129l1.363 2.035h1.216l-1.594-2.136c.746-.157 1.16-.664 1.16-1.437zm-1.99.839h-.285V7.69h.304c.617 0 .948.258.948.755 0 .507-.331.783-.967.783z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.338,
    cy: 9.441,
    r: 2.699,
    fill: "url(#szwtpyirba)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.338,
    cy: 9.441,
    r: 2.699,
    fill: "url(#jnte3nu4mb)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.59.36C.59.266.524.22.423.22H.276v.442h.11V.488l.13.175h.129L.497.48C.553.469.59.424.59.359zM.404.423H.387v-.12h.018c.056 0 .083.018.083.055 0 .046-.027.065-.083.065z",
    transform: "translate(32.79 6.724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.442.055C.23.055.055.23.055.442.055.654.23.83.442.83.654.829.83.654.83.442.829.23.654.055.442.055zm0 .71C.276.764.13.625.13.441.129.267.267.12.442.12c.166 0 .304.147.304.322 0 .175-.138.322-.304.322z",
    transform: "translate(32.79 6.724)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverCard);
export default __webpack_public_path__ + "static/media/discover-card.3ec0f5e249b18bfbb982a9d040b63866.svg";
export { ForwardRef as ReactComponent };